import { FC, useEffect, useState } from "react";
import styles from "./Models.module.scss";
import { GirlItem, IGirlItem } from "../../components/GirlItem/GirlItem";
import { BlockFilter } from "../../components/ui/BlockFilter/BlockFilter";
import { Pagination } from "../../components/ui/Pagination/Pagination";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import { getUsers, getUsersFilters } from "../../api/user";
import Loader from "../../components/Loader/Loader";
import { IResponseGetUsers } from "../../types/user";
import { transformUsersToGirlItems } from "../../helpers/transform-user-to-models";
import { useLocation } from "react-router-dom";

const pageSize = 12;

export const Models: FC = () => {
  const [girls, setGirls] = useState<IGirlItem[]>([]);
  const [currentGirls, setCurrentGirls] = useState<IGirlItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const location = useLocation();
  useEffect(() => {
    setCurrentPage(1);
    setTotalCount(girls.length);
  }, [girls]);

  useEffect(() => {
    let arr = [...girls];

    setCurrentGirls(
      arr.slice(currentPage * pageSize - pageSize, currentPage * pageSize),
    );
  }, [currentPage, girls]);

  async function fetchData() {
    try {
      setIsLoading(true);
      const data: { users: IResponseGetUsers[] } = await getUsers();
      const girlsData = transformUsersToGirlItems(data.users);
      setGirls(girlsData);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.toString()) {
      setIsLoading(true);

      getUsersFilters(query.toString())
        .then((users: IResponseGetUsers[]) => {
          const girlsData = transformUsersToGirlItems(users);
          setGirls(girlsData);
        })
        .finally(() => setIsLoading(false));
    } else {
      fetchData();
    }
  }, [location.search]);

  if (isLoading)
    return (
      <div className="loader-container">
        <Loader size={100} borderWidth={7} />
      </div>
    );

  return (
    <div className={styles.models}>
      <BlockFilter count={girls.length} setGirls={setGirls} />
      <div className={styles.girls}>
        <ul className={styles.girlCards}>
          {currentGirls &&
            currentGirls.length > 0 &&
            currentGirls.map((girl) => <GirlItem {...girl} key={girl.id} />)}
        </ul>
      </div>
      <div className={styles.pagination}>
        <Pagination
          pageSize={pageSize}
          totalCount={totalCount}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};
